<template>
  <div>
    <b-row align-v="center" class="loader" v-if="is_saving">
        <b-col>
            <b-spinner></b-spinner>
            <br><br>
            <strong>Loading</strong>
        </b-col>
    </b-row>
    <b-form @submit="save">
      <b-form-group
        label="Job Title:"
        description="This field is required"
      >
        <b-form-input
          v-model="form.description"
          type="text"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
              label="Monthly Rate:"
              description="This field is required"
      >
        <b-form-input
                v-model="form.monthly_rate.default"
                type="number"
                step="any"
                required
        ></b-form-input>
      </b-form-group>
      <b-form-group
              label="Daily Rate:"
              description="This field is required"
      >

        <b-input-group>
          <b-form-input
                  v-model="form.daily_rate.default"
                  type="number"
                  step="any"
                  required
          ></b-form-input>
          <template #append>
            <b-input-group-text class="bg-info text-white">Projected Daily Rate:<strong class="ml-1">P {{daily_rate}}</strong></b-input-group-text>
          </template>
        </b-input-group>

      </b-form-group>
      <b-form-group
              label="Job Description:"
              description="This field is required"
      >

        <b-form-textarea
                id="textarea"
                v-model="form.full_description"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
        ></b-form-textarea>
      </b-form-group>
      <h6>Update Affected Manpower Rates</h6>
      <label class="c-switch c-switch-pill c-switch-success">
        <input type="checkbox" class="c-switch-input" v-model="update_manpower_logs">
        <span class="c-switch-slider"></span>
      </label>
      <h6>Update Affected Project Rates</h6>
      <label class="c-switch c-switch-pill c-switch-success">
        <input type="checkbox" class="c-switch-input" v-model="update_project_rates">
        <span class="c-switch-slider"></span>
      </label>
      <div class="text-right">
        <router-link to="/maintenance/job-descriptions/all">
          <b-button v-if="form.id!=-1" variant="dark" size="sm" class="mr-1">
            <font-awesome-icon icon="chevron-left" /> Back</b-button>
        </router-link>
        <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Save</b-button>
      </div>
    </b-form>
  </div>
</template>
<script>
    import SwalMixin from '@/views/mixins/Swal.js'
    export default {
      mixins:[SwalMixin],
      data() {
        return {
          form: {
            id:-1,
            description: '',
            daily_rate: {
              default:''
            },
            monthly_rate: {
              default:''
            },
            full_description: '',
          },
          form_copy:{},
          is_saving:false,
          update_manpower_logs:false,
          update_project_rates:false
        }
      },
      computed: {
        daily_rate(){
          let daily = Number(this.form.monthly_rate.default/26).toFixed(2);
          return Number(daily).toLocaleString('en-US');
        },
      },
      created(){
        this.form_copy=JSON.parse(JSON.stringify(this.form));
        if(typeof this.$route.params.id !== 'undefined')
        this.get();
      },
      methods: {
        get(){
          this.is_saving=true;
          this.axios.get('maintenance/job_descriptions/get',{params:{id:this.$route.params.id}}).then(response => {
              this.form=response.data;
              this.is_saving=false;
          }).catch(error => console.log(error));
        },
        save(){
          event.preventDefault()
          this.swalConfirmSubmit((data)=>{
              if (data.value) {
                this.is_saving=true;
                let form = JSON.parse(JSON.stringify(this.form));
                form.daily_rate=form.daily_rate.default;
                form.monthly_rate=form.monthly_rate.default;
                form.update_manpower_logs=this.update_manpower_logs;
                form.update_project_rates=this.update_project_rates
                this.axios.post('maintenance/job_descriptions/save',form).then(response => {
                    this.swalTransactionCompleted();
                    this.is_saving=false;
                    this.$emit('refresh');
                    if(this.form.id==-1){
                      this.form=JSON.parse(JSON.stringify(this.form_copy));
                    }
                }).catch(error => {
                    this.swal_transaction_error_data.text = error.response.data;
                    this.swalRequestError();
                    this.is_saving=false;
                });
              }
          });
        }
      }
    }
</script>
